module.exports = __webpack_public_path__ + "static/media/seperate.69832368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/seperate.png
// module id = 1725
// module chunks = 1